import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import { CiEdit } from "react-icons/ci";
import './UserManagement.scss';
import { FaUsers } from 'react-icons/fa';
import { IoMdAdd } from "react-icons/io";
import { MdOutlineSearch } from "react-icons/md";
import {useNavigate}  from 'react-router-dom';
import { IoIosAdd } from "react-icons/io";
import Swal from 'sweetalert2';
import { FaMailBulk } from "react-icons/fa";

const UserManagement = () => {

  const baseURL = 
    process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_API_URL_PROD 
    : process.env.REACT_APP_API_URL_LOCAL;

    const [data, setData] = useState([]);
    //select checkbox for download file
     const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState();
    const [searchData, setSearchData] = useState('');
      const [templateMessage, setTemplateMessage] = useState("");
      
       const textareaRef = useRef(null);
         const popupRef = useRef(null);
          const [templateName, setTemplateName] = useState('');
           const [isOpenTemplate, setIsOpenTemplate] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
          function handleClickOutside(event) {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
              setIsOpen(false);
            }
          }
      
          if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
          } else {
            document.removeEventListener("mousedown", handleClickOutside);
          }
      
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [isOpen]);

          const handleSaveTemplate = async () => {
          
              const token = localStorage.getItem('token');
          
              if (!templateMessage.trim()) return  Swal.fire({
              icon: 'warning',
              title: 'Empty Message',
              text: 'Message cannot be empty.',
            });;
          
              const response = await fetch(`${baseURL}/api/save-researcher-template`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                  name: templateName || null,
                  message: templateMessage,
                }),
              });
          
              const data = await response.json();
              if (response.ok) {
                Swal.fire({
                   icon: "success",
                  text: `Template "${data.template.name}" saved successfully`,
                  confirmButtonColor: "#FCB124",
                  confirmButtonText: "OK",
                })
                setIsOpenTemplate(false);
                setTemplateMessage('');
                setTemplateName('');
              } else {
                Swal.fire({
                  icon:"warning",
                  text:`${data.message}`,
                  confirmButtonColor:"#FCB124",
                  confirmButtonText:"OK"
                })
              }
            };
    
           
  
    const handleInsertText = (text) => {
      const textarea = textareaRef.current;
      if (!textarea) return;
  
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const before = templateMessage.substring(0, start);
      const after = templateMessage.substring(end);
  
      const newMessage = before + text + after;
      setTemplateMessage(newMessage);
  
      // Maintain focus and move cursor
      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd = start + text.length;
      }, 0);
    };
  


    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${baseURL}/api/login`);
            setData(response.data.user);
            console.log(response.data);
        } catch (err) {
            console.error("Failed to fetch admin ID:", err.response?.data?.message || err.message);
        }   
    };


    const handleCheckboxChange = (id) => {
        setSelectedRows((prevSelected) => {
            const isAlreadySelected = prevSelected.includes(id);

            const newSelected = isAlreadySelected
                ? prevSelected.filter((i) => i !== id)
                : [...prevSelected, id];

            return newSelected;
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        }
        setSelectAll(!selectAll);
    };
    const handleSearchChange = (e) =>{
        setSearchData(e.target.value ? e.target.value.toLowerCase() : "")
    }

    const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchData) ||
    item.email.toLowerCase().includes(searchData)
    );

    const handleClickPayment = (id) =>{
        navigate(`/billingandpayment/${id}`);
    }

    const handleClickprofile = (id) =>{
        navigate(`/view-user-profile/${id}`);
    }

     const toggleDropdown = () => {
        setIsOpen(!isOpen);
      };

    return (
        <div className='user-container-table'>
            <div>
                <div className='user-header'>
                    <div className='users-logo'>
                        <FaUsers/>
                        <p>Users</p>
                        <p className='data-count'><strong>{data.length}</strong></p>
                    </div>
                    <div className='search-user'>
                        <input type='text' value={searchData} placeholder='Search...' onChange={handleSearchChange}/>
                        <MdOutlineSearch/>
                    </div>
                     <div className='add-users'>
                       <button  onClick={toggleDropdown} >
                                      Create Template
                                   </button>
                    </div>
                     {isOpen && (
                            <div className="modal-overlay">
                              <div className="modal-content" ref={popupRef}>
                                <div className='campaign' style={{textAlign:"left", fontSize:"15px",fontWeight:'500'}}><FaMailBulk/>
                                 &nbsp;Create Template</div>
                    
                                  <div  style={{marginTop:"20px", textAlign:"left", fontSize:"15px", marginLeft:"10px", }}>
                                    Template Name </div>
                                <input
                                  type="text"
                                  placeholder="Enter your template name"
                                  style={{width:"560px", border:"0.2px solid rgba(0, 0, 0, 0.25)",
                                     height:"22px", borderRadius:"5px", marginTop:"20px", padding:"10px"}}
                                      value={templateName}
                                  onChange={(e) => setTemplateName(e.target.value)}
                                />
                                 <select className="send-email-select" style={{width:"300px", height:"40px", borderRadius:"5px", marginTop:"20px", padding:"10px", marginLeft:"10px"}}
                                  onChange={(e) => handleInsertText(e.target.value)}
                                    defaultValue="">
                                 <option value="" disabled>Instant Variables</option>
                                <option value="{{name}}">Name</option>
                                    <option value="{{date}}">Date</option>
                                    <option value="{{eSendEmailForm}}">SendEmailForm</option>
                                             
                               </select>
                                 <textarea
                               theme="snow"
                            style={{width:"580px", height:"110px", marginTop:"10px", borderRadius:"5px", marginTop:"20px", marginLeft:"10px", border:"1px solid #ccc",}}
                               placeholder="Enter your template message..."
                            
                              name="message"
                               value={templateMessage}
                                  onChange={(e) => setTemplateMessage(e.target.value)}
                                  ref={textareaRef}
                              
                            />
                              
                    
                                <div className="modal-actions">
                                  <button onClick={closeModal} className="cancel-temp-btn">
                                    Cancel
                                  </button>
                                  <button className="save-temp-btn" onClick={handleSaveTemplate}>Save</button>
                                </div>
                              </div>
                            </div>
                          )}
                    <div className='add-users'>
                        <button>ADD USER</button>
                    </div>
                </div>
                <hr/>
                <div className='table-container-user' style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <table className='user-table'>
                        <thead>
                            <tr>
                                <th><input type="checkbox" checked={selectAll} onChange={handleSelectAll} /></th>
                                <th>USER NAME</th>
                                <th>EMAIL</th>
                                <th>ROLE</th>
                                <th>ACTIONS</th>
                                <th>Profile</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(user => (
                                <tr key={user._id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            value={user._id}
                                            checked={selectedRows.includes(user._id)}
                                            onChange={() => handleCheckboxChange(user._id)}
                                        /></td>
                                    <td>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.role}</td>
                                    <td onClick={()=>handleClickPayment(user._id)}><CiEdit/></td>
                                    <td onClick={()=>handleClickprofile(user._id)}>Profile</td>
                                </tr>))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default UserManagement;